import { DataChannel, Channel } from './channel';
import { UpdateTargetGroupResponse } from '../http-services/target-group.httpservice';

export const targetGroupInfieldChannel = {
  updated: new DataChannel<UpdateTargetGroupResponse>(),
  refreshQuotaStats: new Channel(),
};
